export {default} from 'views/Ibs/Ibs'



// WEBPACK FOOTER //
// ./src/views/Administration/Ibs.jsx